import {NgModule,} from '@angular/core';
import {IonicModule, IonicPageModule} from "ionic-angular";
import {SellionsLayoutRendererLibModule} from "../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/sellions-layout-renderer-lib.module";
import {GenericDataViewService} from "../generic-data-view.service";
import {GenericDataViewListPage} from "./generic-data-view-list.page";
import {ProcessService} from "../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/services/process/process.service";
import {ComponentsModule} from "../../shared/components/components.module";

@NgModule({
  declarations: [GenericDataViewListPage],
  imports: [
    IonicPageModule.forChild(GenericDataViewListPage),
    SellionsLayoutRendererLibModule,
    IonicModule,
    ComponentsModule
  ],
  entryComponents: [GenericDataViewListPage],
  providers: [GenericDataViewService, ProcessService],
  exports: [GenericDataViewListPage]
})
export class GenericDataViewListPageModule {
}



// WEBPACK FOOTER //
// ./src/generic-data-view/generic-data-view-list/generic-data-view-list.page.module.ts